import React, { useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { FaPalette } from "react-icons/fa";
import { FaLocationDot } from "react-icons/fa6";
import { FaTags } from "react-icons/fa";
import { GiWeight } from "react-icons/gi";
import { FaTruckMoving } from "react-icons/fa";
import { FaHammer } from "react-icons/fa6";
import { FaAddressBook } from "react-icons/fa6";
import { FaShoppingCart } from "react-icons/fa";
import { FaGears } from "react-icons/fa6";
import { GiRolledCloth } from "react-icons/gi";
import { MdAccountBalance } from "react-icons/md";
import { MdPayments } from "react-icons/md";
import { FaStackOverflow } from "react-icons/fa6";
import { MdPendingActions } from "react-icons/md";
import logo from '../assets/images/logo.png'
import { FaMoneyCheck } from "react-icons/fa";
import { FaUser } from "react-icons/fa";
import { AiFillHome } from "react-icons/ai";
import { FaPowerOff } from "react-icons/fa6";
import { FaUserGroup } from "react-icons/fa6";
import { FaTruckLoading } from "react-icons/fa";
import { useDispatch, useSelector } from 'react-redux';
import { logoutAction } from '../redux/feature/authSlice';
import { BiSolidReceipt } from "react-icons/bi";
import { FaArrowRotateLeft } from "react-icons/fa6";
import { FaHome } from "react-icons/fa";

const Navbar = () => {

    const isLoggedIn = useSelector(state => state.auth.value.isLoggedIn)

    const nav = useNavigate()
    const dispatch = useDispatch()

    // Aktif sekme URL'den türetilir: /purchase/edit/5 -> 'purchase', / -> ''
    const { pathname } = useLocation()
    const firstSegment = pathname.split('/')[1] || ''
    const tab = firstSegment === 'returnment' ? 'returnment-archive' : firstSegment


    // Normal tık uygulama içi sekmede açar, Ctrl/Cmd + tık veya orta tık tarayıcıda yeni sekme açar
    const handleLinkClick = (e, link) => {
        if (e.ctrlKey || e.metaKey || e.button === 1) {
            window.open('/' + link.to, '_blank', 'noopener')
            return
        }
        nav('/' + link.to)
    };

    const links = [
        {
            title: "Dashboard",
            links: [
                {
                    title: "Dashboard",
                    to: '',
                    icon: <FaHome />
                }
            ]
        },
        {
            title: 'Ürün',
            links: [
                {
                    title: "Renk",
                    to: 'color',
                    icon: <FaPalette />
                },
                {
                    title: "Desen",
                    to: 'pattern',
                    icon: <FaStackOverflow />
                },
                {
                    title: "Gramaj",
                    to: 'weight',
                    icon: <GiWeight />
                },
                {
                    title: "Lokasyon",
                    to: 'location',
                    icon: <FaLocationDot />
                },
                {
                    title: "Ürün",
                    to: 'product',
                    icon: <FaTags />
                },
            ]
        },
        {
            title: "İş Ortakları",
            links: [
                {
                    title: "Tedarikçi",
                    to: 'supplier',
                    icon: <FaTruckMoving />
                },
                {
                    title: "Fasoncu",
                    to: 'outsourcer',
                    icon: <FaHammer />
                },
                {
                    title: "Müşteri",
                    to: 'customer',
                    icon: <FaAddressBook />
                },
            ]
        },

        {
            title: 'Satın Alım',
            links: [
                {
                    title: "Satın Alım",
                    to: 'purchase',
                    icon: <FaTruckLoading />
                },
            ]
        },
        {
            title: "Üretim",
            links: [
                {
                    title: "İşlem",
                    to: 'operation',
                    icon: <MdPendingActions />
                },
                {
                    title: "Üretim",
                    to: 'production-record',
                    icon: <FaGears />
                }
            ]
        },
        {
            title: 'Sipariş',
            links: [
                {
                    title: "Sipariş",
                    to: 'order',
                    icon: <FaShoppingCart />
                },
            ]
        },
        {
            title: 'İade',
            links: [
                {
                    title: "İade Geçm.",
                    to: 'returnment-archive',
                    icon: <FaArrowRotateLeft />
                },
            ]
        },
        {
            title: 'Finans',
            links: [
                {
                    title: "Hesap",
                    to: 'account',
                    icon: <MdAccountBalance />
                },
                {
                    title: "Ödeme",
                    to: 'payment',
                    icon: <MdPayments />
                },
                {
                    title: "Çek",
                    to: 'cheque',
                    icon: <FaMoneyCheck />
                },
                // {
                //     title: "Ekstre",
                //     to: 'receipt',
                //     icon: <BiSolidReceipt />
                // },
            ]
        },

        {
            title: 'Stok',
            links: [
                {
                    title: "Stok",
                    to: 'stock',
                    icon: <GiRolledCloth />
                },
            ]
        },
        {
            title: 'Kullanıcı',
            links: [
                {
                    title: "Kullanıcı",
                    to: 'user',
                    icon: <FaUserGroup />
                },
                // {
                //     title: "Profil",
                //     to: 'profile',
                //     icon: <FaUser />
                // }
            ]
        },

    ]

    let [darkMode, setDarkMode] = useState(() => { return JSON.parse(localStorage.getItem('imperteks-darkMode')) || false })

    useEffect(() => {
        if (darkMode) {
            document.documentElement.classList.add('dark')
        } else {
            document.documentElement.classList.remove('dark')
        }
        localStorage.setItem('imperteks-darkMode', JSON.stringify(darkMode));
    }, [darkMode])

    return (
        <div className='bg-purple-700 h-screen sticky top-0 p-1 shadow-lg flex flex-col justify-between dark:bg-black'>
            <div>
                <img src={logo} className='mb-1 mt-0' />
                {/* <div onClick={() => setDarkMode(!darkMode)}>
                    {darkMode ? 'light' : 'dark'} mode

                </div> */}
                {
                    isLoggedIn &&
                    links.map((section, index) => (
                        <div key={index} className='mb-0.5'>
                            {section.title && <label className='text-xs text-white tracking-wider border-b block mb-1'>{section.title} </label>}
                            {
                                section.links.map((link, i) => (
                                    <div
                                        key={i}
                                        onClick={e => handleLinkClick(e, link)}
                                        onAuxClick={e => e.button === 1 && handleLinkClick(e, link)}
                                        className={`${tab === link.to ? "bg-white text-purple-700 dark:text-black" : "text-zinc-100"} flex uppercase items-center gap-x-2  block cursor-pointer hover:bg-white hover:text-purple-700 p-0.5 duration-150 rounded-sm dark:hover:text-black`}
                                    >
                                        {link.icon}
                                        <label className='text-sm'>{link.title}</label>
                                    </div>
                                ))
                            }
                        </div>
                    ))
                }
            </div>

            <div
                className='text-zinc-100 flex gap-x-2 text-xs items-center p-1 hover:bg-white hover:text-purple-700 duration-150 cursor-pointer rounded-sm'
                onClick={() => dispatch(logoutAction())}
            >
                <FaPowerOff />
                <label className='cursor-pointer'>Çıkış Yap</label>
            </div>



        </div>
    )
}

export default Navbar